import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import CookieConsent from './components/CookieConsent';
import Home from './pages/Home';
import Event from './pages/Event';
import Sponsors from './pages/Sponsors';
import About from './pages/About';
import Categories from './pages/Categories';
import JudgingProcess from './pages/JudgingProcess';
import Tickets from './pages/Tickets';
import Winners from './pages/Winners';
import Terms from './pages/Terms';
import PrivacyPolicy from './pages/PrivacyPolicy';

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-grow pt-16">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/judging-process" element={<JudgingProcess />} />
            <Route path="/winners" element={<Winners />} />
            <Route path="/event" element={<Event />} />
            <Route path="/sponsors" element={<Sponsors />} />
            <Route path="/tickets" element={<Tickets />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/about" element={<About />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          </Routes>
        </main>
        <Footer />
        <CookieConsent />
      </div>
    </Router>
  );
}

export default App;